export const MenuMixin = {
    data: () => ({
      isMenuOpen: false
    }),
    methods: {
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      }
    }
  };
  